import { Route } from "react-router";
import { Routes } from "react-router-dom";
import ActivityDataPage from "./pages/ActivityData";
import ActivityDataPointPage from "./pages/ActivityDataPoint";
import DataSourceAddPage from "./pages/DataSourceAdd";
import DataSourceAddActivityPage from "./pages/DataSourceAddActivityData";
import DataSourceDetailPage from "./pages/DataSourceDetail";
import DataSourceEmissionsFactorHistoryPage from "./pages/DataSourceEmissionsFactorHistory";
import DataSourcesPage from "./pages/DataSources";
import HomePage from "./pages/Home";
import NotFoundPage from "./pages/NotFound";
import RequiredEvidencePage from "./pages/RequiredEvidence";
import EmissionsSourceEvidenceHistoryPage from "./pages/EmissionsSourceEvidenceHistory";
import OrganizationEvidenceHistoryPage from "./pages/OrganizationEvidenceHistory";
import EmissionsSourcesPage from "./pages/EmissionsSources";
import ReportsPage from "./pages/Reports";
import EmissionsSourceCreatePage from "./pages/EmissionsSourceCreate";
import EmissionsSourceDetailPage from "./pages/EmissionsSourceDetail";
import EmissionsSourceEditPage from "./pages/EmissionsSourceEdit";
import CalculationVeracityPage from "./pages/CalculationVeractityPage";
import { FinancedEmissionsHistoryPage } from "./pages/FinancedEmissionsHistoryPage";

export const appPaths = {
    home: "/",
    dataSources: "/data-sources",
    dataSourceAdd: "/data-sources/add",
    dataSourceDetail: (id: string) => `/data-sources/${id}`,
    dataSourceAddActivity: (id: string) => `/data-sources/${id}/add-activity`,
    dataSourceEmissionsFactorHistory: (id: string) =>
        `/data-sources/${id}/emissions-factor-history`,
    activityData: "/activity-data",
    activityDataPoint: (id: string) => `/activity-data/${id}`,
    evidence: "/evidence",
    emissionsSourceEvidenceHistory: (
        emissionsSourceId: string,
        evidenceTypeId: string
    ) =>
        `/emissions-sources/${emissionsSourceId}/evidence-history/${evidenceTypeId}`,
    organizationEvidenceHistory: (id: string) =>
        `/evidence/organization/history/${id}`,
    emissionsSources: (isMaterial?: boolean) => {
        if (isMaterial === undefined) return "/emissions-sources";
        return `/emissions-sources?selectedTab=${
            isMaterial ? "material" : "not-material"
        }`;
    },
    emissionsSourceDetail: (id: string) => `/emissions-sources/${id}`,
    emissionsSourceCreate: "/emissions-sources/create",
    emissionsSourceEstimates: (id: string) =>
        `/emissions-sources/${id}/estimates`,
    emissionsSourceEdit: (id: string) => `/emissions-sources/${id}/update`,
    calculationVeracity: (sector: string, scopes: string, year: string) => `/reports/financed-emissions/${sector}/origin?scopes=${scopes}&year=${year}`,
    reports: "/reports",
    reportsByYear: (year: string) => `/reports?year=${year}`,
    financedEmissionsHistory: (sector: string, scopes: string, year: string) => `/reports/financed-emissions/${sector}/history?scopes=${scopes}&year=${year}`
};

const AppRoutes = () => {
    return (
        <Routes>
            <Route path={appPaths.home} element={<HomePage />} />
            <Route path={appPaths.dataSources} element={<DataSourcesPage />} />
            <Route
                path={appPaths.dataSourceDetail(":id")}
                element={<DataSourceDetailPage />}
            />
            <Route
                path={appPaths.dataSourceAdd}
                element={<DataSourceAddPage />}
            />
            <Route
                path={appPaths.dataSourceAddActivity(":id")}
                element={<DataSourceAddActivityPage />}
            />
            <Route
                path={appPaths.dataSourceEmissionsFactorHistory(":id")}
                element={<DataSourceEmissionsFactorHistoryPage />}
            />
            <Route
                path={appPaths.emissionsSources()}
                element={<EmissionsSourcesPage />}
            />
            <Route
                path={appPaths.emissionsSourceDetail(":id")}
                element={<EmissionsSourceDetailPage />}
            />
            <Route
                path={appPaths.emissionsSourceCreate}
                element={<EmissionsSourceCreatePage />}
            />
            <Route
                path={appPaths.emissionsSourceEdit(":id")}
                element={<EmissionsSourceEditPage />}
            />
            <Route
                path={appPaths.activityData}
                element={<ActivityDataPage />}
            />
            <Route
                path={appPaths.activityDataPoint(":id")}
                element={<ActivityDataPointPage />}
            />
            <Route
                path={appPaths.evidence}
                element={<RequiredEvidencePage />}
            />
            <Route
                path={appPaths.emissionsSourceEvidenceHistory(
                    ":emissionsSourceId",
                    ":evidenceTypeId"
                )}
                element={<EmissionsSourceEvidenceHistoryPage />}
            />
            <Route
                path={appPaths.organizationEvidenceHistory(":id")}
                element={<OrganizationEvidenceHistoryPage />}
            />
            <Route path={appPaths.reports} element={<ReportsPage />} />
            <Route path={"reports/financed-emissions/:sector/origin"} element={<CalculationVeracityPage />} />
            <Route path={"reports/financed-emissions/:sector/history"} element={<FinancedEmissionsHistoryPage />} />
            <Route path="*" element={<NotFoundPage />} />
        </Routes>
    );
};

export default AppRoutes;
